import Header from "../../components/header";
import LeftMenu from "../../components/left-menu";
import Grid from '@mui/material/Grid';
import "./style.css";
import React, {Component} from 'react';
import axios from "axios";
import { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';


const product = [
    { product: 'Virtual Office Plain Package'},
    { product: 'Virtual Office Public Package'},
    { product: 'Virtual Office Premium Package'},
    { product: 'Virtual Office Preestige Package'},
    { product: 'Private Office'},
    { product: 'Pendirian PT'},
    { product: 'Pendirian CV'},
    { product: 'Meeting Room'},
  ];

export default function AddAddress(){

    const [address1,setAddress1] = useState("")
    const [address2,setAddress2] = useState("")
    const [address3,setAddress3] = useState("")
    const [phone,setPhone] = useState("")

    async function tambahAlamat(e){
        e.preventDefault()

        try{
        const {data} = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/add-address`,{
            address1, address2, address3, phone
        });
        setAddress1("")
        setAddress2("")
        setAddress3("")
        setPhone("")
        console.log("berhasil")
        }catch(error){
        console.log("error")
    };}

    return <Grid container>
                <Grid item xl={1.2} lg={1.9} md={2.6} sm={3.2} className="leftmenucolor">
                    <LeftMenu/>
                </Grid>
                <Grid item xl={10.8} lg={10.1} md={9.4} sm={8.8}>
                    <Grid className="boxshadowclass">
                        <Header></Header>
                    </Grid>
                    <Grid>
                    <form onSubmit={tambahAlamat}>
                    <Grid sx={{ mt:10, ml:10 }}>
                        <TextField value={address1} label="Address1" onChange={(e) => setAddress1(e.target.value)}></TextField>
                        <TextField value={address2} label="Address2" onChange={(e) => setAddress2(e.target.value)}></TextField>
                        <TextField value={address3} label="Address3" onChange={(e) => setAddress3(e.target.value)}></TextField>
                        <TextField value={phone} label="Phone" onChange={(e) => setPhone(e.target.value)}></TextField>

                        <Button sx={{ mt: 2 }} type="submit" variant="contained">Tambah Alamat</Button>
                    </Grid>
                    </form>
                    </Grid>
                </Grid>    
            </Grid>
    };